import React from 'react'
import style from './Point.module.css'

const point = props => {
	return (
		<div className={style.container}>
			<h3 className={style.heading}>
				{props.section}.{props.index} {props.heading}
			</h3>
			{props.body}
		</div>
	)
}

export default point
